<template>
  <div class="animated fadeIn mt-5">
    <form
      enctype="multipart/form-data"
      v-on:submit="validateBeforeSubmit($event, false)"
      v-if="dataLoaded"
    >
      <b-card>
        <div slot="header">
          <strong>Template</strong>
        </div>

        <b-row>
          <b-col md="6">
            <modal-select v-if="!item.id"
              label="Actividade"
              namevar="name"
              modal="activities-modal"
              name="activity_id"
              v-bind:item-id="item.activity_id"
              v-bind:item-code="item.activity.data.code"
              v-bind:item-name="item.activity.data.name"
              v-on:select-item="selectActivity"
            ></modal-select>
            <b-row>
              <b-col md="4">
                <b-form-group label="Email">
                  <b-form-select v-model="item.template_id" :disabled="item.id>0" :options="filteredMailables"></b-form-select>
                </b-form-group>

              </b-col>
              <b-col md="6">
                <b-form-group label="Estado">
                  <b-form-select v-model="item.state" :disabled="this.item.activity_id == 0" :options="states.states"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Ordem">
                  <b-form-input
                      type="text"
                      name="ordering"
                      v-model="item.ordering"
                      placeholder="Assunto"
                      v-validate="{ required: true }"
                      :state="validateState('ordering')"
                      data-vv-validate-on="change"
                    ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-fieldset label="Assunto">
              <b-form-input
                type="text"
                name="subject"
                v-model="item.subject"
                placeholder="Assunto"
                v-validate="{ required: true }"
                :state="validateState('subject')"
                data-vv-validate-on="change"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first("subject") }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
          </b-col>
        </b-row>
        <b-form-group>

        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-fieldset
              v-if="editorMode == 'markdown'"
              label="Template Markdown"
            >

          <b-btn
            variant="info"
            size="sm"
            @click="changeEditor('html')"
            v-if="editorMode == 'markdown'"
            :disabled="!item.allow_markdonw"
            >Editar em HTML</b-btn>
              <codemirror
                v-model="item.markdown_text"
                :options="cmOptionsMark"
              />
              <p>
                Formatação do texto em Markdown
                <a
                  href="https://www.markdownguide.org/cheat-sheet/"
                  target="_blank"
                  >markdownguide.org</a
                >
              </p>
            </b-form-fieldset>
            <b-form-fieldset label="Template HTML" v-if="editorMode == 'html'">
               <b-btn
            variant="info"
            size="sm"
            @click="changeEditor('markdown')"
            v-if="editorMode == 'html'"
            :disabled="!item.allow_markdonw"
            >Editar em Markdown</b-btn>
              <codemirror v-model="item.template_html" :options="cmOptions" />
            </b-form-fieldset>
          </b-col>
          <b-col md="6">

                <b-table striped hover :items="activeReplacements" :fields="replacementFields">
                  <!-- A custom formatted column -->
                  <template #cell(str)="data">
                    {{ '{'+data.value+'}' }}
                  </template>
                </b-table>
          </b-col>
        </b-row>

        <div slot="footer">
          <div class="row">
            <div class="col-sm-3">
              <router-link
                :to="{ name: baseRoute + '.index' }"
                size="sm"
                variant="danger"
                ><i class="fa fa-ban"></i> Cancelar</router-link
              >
            </div>
            <div class="col-sm-9 text-right">
              <b-button type="submit" size="sm" variant="primary"
                ><i class="fa fa-save"></i> Gravar</b-button
              >
              <b-button
                type="button"
                v-on:click="validateBeforeSubmit($event, true)"
                size="sm"
                variant="primary"
                ><i class="fa fa-save"></i> Gravar e fechar</b-button
              >
            </div>
          </div>
        </div>
      </b-card>

      <!--/.col-->
    </form>
  </div>
</template>

<script>
import marked from "marked";
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/xml/xml.js";
import States from '@/components/Lists.js';

var TurndownService = require("turndown").default;
console.log(TurndownService);

export default {
  name: "emailtemplatesEdit",
  props: ["id"],
  components: { codemirror },
  data() {
    return {
      url: "email/templates",
      baseRoute: "emailtemplates",
      dataLoaded: false,
      memberTypes: [],
      turndownService: null,
      mailables: [],
      states: States,
      regions: [],
      editorMode: "markdown",
      cmOptions: {
        tabSize: 4,
        mode: "text/html",
        theme: "material",
        lineNumbers: true,
        line: true,
        // more CodeMirror options...
      },
      cmOptionsMark: {
        tabSize: 4,
        mode: "text/x-markdown",
        theme: "material",
        lineNumbers: true,
        line: true,
        // more CodeMirror options...
      },
      replacementFields: [{
        key: 'str',
        label: 'Variavel'
      }, {
        key: 'desc',
        label: 'Descrição'
      }],
      item: {
        name: "",
        activity_id: null,
        markdown_text: "",
        template_html: "",
        subject: "",
        activity: {
          data: {},
        },
      },
    };
  },
  computed: {
    filteredMailables: function () {
      if( this.item.id > 0 ) {
        return this.mailables
      }
      return this.mailables.filter(item => item.allow_create == 1)
    },
    compiledTemplate: function () {
      if (this.editorMode == "markdown") {
        return marked(this.item.markdown_text, { sanitize: false });
      }
      return this.item.template_html;
    },
    activeReplacements: function() {
      if(!this.item.template_id) {
        return null
      }
      for(let i=0; i<this.mailables.length; i++) {
        if(this.mailables[i].value == this.item.template_id) {
          return this.mailables[i].replaces
        }
      }
      return null
    }
  },
  methods: {
    changeEditor(editorMode) {
      if (this.editorMode == "html") {
        this.item.markdown_text = this.turndownService.turndown(
          this.item.template_html
        );
      }
      if (this.editorMode == "markdown") {
        this.item.template_html = marked(this.item.markdown_text, {
          sanitize: false,
        });
      }
      this.editorMode = editorMode;
    },
    selectActivity(e) {
      if (e.item) {
        console.log(e.item);
        this.item.activity_id = e.item.id;
        this.item.activity.data = e.item;
      } else {
        this.item.activity_id = null;
        this.item.activity.data = { id: null, name: null };
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault();
      console.log("check validation");
      this.$validator.validateAll().then((result) => {
        console.log("validation results:", result);
        if (result) {
          console.log("all fields ok. submit");
          this.submit(evt, close);
          return;
        }
        this.$bvToast.toast("Tem campos inválidos", {
          autoHideDelay: 5000,
          variant: "danger",
          solid: true,
        });
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    submit(e, close) {
      e.preventDefault();
      if (this.editorMode == "markdown") {
        this.item.template_html = marked(this.item.markdown_text, {
          sanitize: false,
        });
      }
      var data = {
        data: this.item,
      };
      if (this.item.id) {
        this.axios
          .put(this.url + "/" + this.item.id, data)
          .then((response) => {
            this.item = response.data.data;
            this.$bvToast.toast("item gravado com sucesso", {
              autoHideDelay: 5000,
              variant: "success",
              solid: true,
            });
            if (close) {
              this.$router.push({
                name: this.baseRoute + ".index",
              });
            }
          })
          .catch((response) => {
            this.$bvToast.toast("Não foi possivel gravar", {
              autoHideDelay: 5000,
              variant: "danger",
              solid: true,
            });
          });
      } else {
        this.axios
          .post(this.url, data)
          .then((response) => {
            this.item = response.data.data;
            this.$bvToast.toast("item gravado com sucesso", {
              autoHideDelay: 5000,
              variant: "success",
              solid: true,
            });
            this.$router.push({
              name: this.baseRoute + ".edit",
              params: {
                id: this.item.id,
              },
            });
          })
          .catch((response) => {
            this.$bvToast.toast("Não foi possivel gravar", {
              autoHideDelay: 5000,
              variant: "danger",
              solid: true,
            });
          });
      }
    },
  },
  created() {
    var id = this.$route.params.id;
    this.axios.get('email/templates/mailables').then(response => {
      this.mailables = response.data.data
    })
    if (typeof id !== "undefined") {
      this.axios
        .get(this.url + "/" + id)
        .then((response) => {
          this.item = response.data.data;
          if (this.item.allow_markdonw == 0) {
            this.editorMode = "html";
          }
          this.dataLoaded = true;
        })
        .catch((response) => {
          this.$bvToast.toast("Esta actividade não existe", {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          this.$router.push({
            name: this.baseRoute + ".index",
          });
        });
    } else {
      this.dataLoaded = true;
    }
  },
  mounted() {
    this.turndownService = new TurndownService();
  },
};
</script>
